export type SparkChannelFields = {
  channel?: 'spark' | null;
  sparkChatId?: string | null;
  sparkEntrypointId?: string | null;
  sparkLinePhone?: string | null;
  sparkLineLabel?: string | null;
};

export function isSparkContact(opts: {
  channel?: 'spark' | null;
  sparkChatId?: string | null;
  sparkEntrypointId?: string | null;
}): boolean {
  return opts.channel === 'spark' || Boolean(opts.sparkChatId) || Boolean(opts.sparkEntrypointId);
}

/** Campos Spark de websocket/API — lead novo no chat precisa disto para não cair no Uazapi. */
export function pickSparkFieldsFromRealtime(data: Record<string, unknown> | null | undefined): SparkChannelFields {
  if (!data) return {};
  const sparkChatId = (data.sparkChatId ?? data.spark_chat_id ?? data.SparkChatId ?? null) as string | null;
  const sparkEntrypointId = (data.sparkEntrypointId ?? data.spark_entrypoint_id ?? data.SparkEntrypointId ?? null) as string | null;
  const sparkLinePhone = (data.sparkLinePhone ?? data.spark_line_phone ?? data.SparkLinePhone ?? null) as string | null;
  const sparkLineLabel = (data.sparkLineLabel ?? data.spark_line_label ?? data.SparkLineLabel ?? null) as string | null;
  const rawChannel = data.channel ?? data.Channel;
  const channel =
    rawChannel === 'spark' || Boolean(sparkChatId) || Boolean(sparkEntrypointId)
      ? 'spark' as const
      : null;
  return { channel, sparkChatId, sparkEntrypointId, sparkLinePhone, sparkLineLabel };
}

/** Rótulo discreto do WhatsApp oficial de entrada (header do chat). */
export function formatSparkOriginLabel(opts: {
  channel?: 'spark' | null;
  sparkChatId?: string | null;
  sparkLinePhone?: string | null;
  sparkLineLabel?: string | null;
}): string | null {
  if (!isSparkContact(opts)) return null;
  const phone = opts.sparkLinePhone?.trim();
  if (phone) return `WhatsApp oficial · ${phone}`;
  const label = opts.sparkLineLabel?.trim();
  if (label) return `WhatsApp oficial · ${label}`;
  return 'WhatsApp oficial';
}
